import React, { useState, useEffect } from "react";
import { Dropdown, Button, Tooltip } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import DoctorLayout from './../../Layouts/Doctor/DoctorLayout';
import RejectAppointmentModal from "../../Components/Receptionist/Appointment/RejectAppointmentModal";
import RescheduleAppointmentModal from "../../Components/Receptionist/Appointment/RescheduleAppointmentModal";
import ConfirmAppointmentModal from "../../Components/Receptionist/Appointment/ConfirmAppointmentModal";
import { getAppointments } from "../../Services/doctorService";
import AppointmentModal from "../../Components/Modal/AppointmentModal";
import PremiumLoader from './../../Components/Common/Loader/PremiumLoader';
import Pagination from "../../Components/Common/Pagination/Pagination";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { cancelAppointment, confirmAppointment, rejectAppointment, rescheduleAppointment } from "../../Services/appointmentService";
import EditAppointmentModal from "../../Components/Modal/EditAppointmentModal";
import CancelAppointmentModal from "../../Components/Receptionist/Appointment/CancelAppointmentModal";
import ConcernAppointmentModal from "../../Components/Receptionist/Appointment/ConsernAppointmentModal";
import { formatDateDDMMYYYY, formatTime } from "../../Utils/dateUtils";


export default function DoctorDashboard() {

    const navigate = useNavigate();
    const [sessionUserData, setSessionUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [appointmentsCache, setAppointmentsCache] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const [branchId, setBranchId] = useState(null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [showAppointmentModal, setShowAppointmentModal] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [isConsentModalOpen, setIsConsentModalOpen] = useState(false);

    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem("userData"));

        if (userData) {
            setSessionUserData(userData);
            setBranchId(userData?.UnitId);
        }
    }, []);

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
    });

    const actionClass = "d-flex align-items-center gap-2 fw-semibold py-1";

    const getActionItems = (record) => {
        // 1. Parse Status Logic for the 'Confirm' Action
        const recordStatus = String(record?.Status || "").toUpperCase();
        const isConfirmDisabled = !["BOOKED", "RESCHEDULED"].includes(recordStatus);

        // 2. Dynamic Tooltip Helper for Confirm Statuses
        const getConfirmDisabledReason = (status) => {
            switch (status) {
                case "CONFIRMED":
                    return "This appointment is already confirmed.";
                case "CANCELLED":
                    return "Cannot confirm a cancelled appointment.";
                case "COMPLETED":
                    return "This appointment has already been completed.";
                default:
                    return "Action unavailable for current status.";
            }
        };

        // 3. Parse Logic for the 'View' Action
        const isViewDisabled = record?.Status === "BOOKED";

        return [
            {
                key: "view",
                disabled: false, // Omit/set false so AntD allows mouse-hover tooltips
                label: (
                    <Tooltip
                        title={isViewDisabled ? "No signature document uploaded yet." : ""}
                        placement="left"
                    >
                        <span
                            className={`${actionClass} ${isViewDisabled ? "text-muted opacity-50" : ""}`}
                            style={{ cursor: isViewDisabled ? 'not-allowed' : 'pointer', display: 'flex', width: '100%' }}
                        >
                            <i className={`bi bi-eye ${isViewDisabled ? "text-muted" : "text-primary"} me-2`}></i>
                            View
                        </span>
                    </Tooltip>
                ),
                onClick: () => !isViewDisabled && handleMenuClick("view", record),
            },
            {
                key: "edit",
                label: (
                    <span className={actionClass}>
                        <i className="bi bi-pencil-square text-info"></i>
                        Edit
                    </span>
                ),
                onClick: () => handleMenuClick("edit", record),
            },
            {
                key: "consent",
                label: (
                    <span className={actionClass}>
                        <i className="bi bi-pen text-primary"></i>
                        Consent
                    </span>
                ),
                onClick: () => handleMenuClick("consent", record),
            },
            {
                key: "confirm",
                disabled: false, // Allowed hover state tracking 
                label: (
                    <Tooltip
                        title={isConfirmDisabled ? getConfirmDisabledReason(recordStatus) : ""}
                        placement="left"
                    >
                        <span
                            className={`${actionClass} ${isConfirmDisabled ? 'premium-menu-disabled' : ''}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                cursor: isConfirmDisabled ? 'not-allowed' : 'pointer'
                            }}
                        >
                            <i className={`bi bi-check2-circle ${isConfirmDisabled ? 'text-muted' : 'text-success'} me-2`}></i>
                            <span style={{ color: isConfirmDisabled ? '#94a3b8' : 'inherit' }}>
                                Confirm
                            </span>
                        </span>
                    </Tooltip>
                ),
                onClick: () => {
                    if (!isConfirmDisabled) {
                        handleMenuClick("confirm", record);
                    }
                },
            },
            {
                key: "reschedule",
                disabled: true,

                label: (
                    <Tooltip
                        title="Coming Soon"
                        placement="left"
                    >
                        <span
                            className={`${actionClass} text-muted opacity-50`}
                            style={{
                                cursor: "not-allowed",
                            }}
                        >
                            <i className="bi bi-calendar2-week text-muted"></i>

                            Reschedule
                        </span>
                    </Tooltip>
                ),

                onClick: () => { },
            },
            {
                key: "cancel",
                disabled: true,

                label: (
                    <Tooltip
                        title="Coming Soon"
                        placement="left"
                    >
                        <span
                            className={`${actionClass} text-muted opacity-50`}
                            style={{
                                cursor: "not-allowed",
                            }}
                        >
                            <i className="bi bi-calendar2-x text-muted"></i>

                            Cancel
                        </span>
                    </Tooltip>
                ),

                onClick: () => { },
            },
            {
                type: "divider",
            },
            {
                key: "reject",
                disabled: true,

                label: (
                    <Tooltip
                        title="Coming Soon"
                        placement="left"
                    >
                        <span
                            className={`${actionClass} text-muted opacity-50`}
                            style={{
                                cursor: "not-allowed",
                            }}
                        >
                            <i className="bi bi-x-octagon text-muted"></i>

                            Reject
                        </span>
                    </Tooltip>
                ),

                onClick: () => { },
            },
        ];
    };

    const handleMenuClick = (action, record) => {
        setSelectedAppointment(record);

        if (action === "view") {
            navigate(`/doctor/consultation/${record.AppointmentId}`, {
                state: record,
            });
            return;
        }

        if (action === "edit") setIsEditModalOpen(true);
        if (action === "confirm") setIsConfirmModalOpen(true);
        if (action === "reschedule") setIsRescheduleModalOpen(true);
        if (action === "reject") setIsRejectModalOpen(true);
        if (action === "cancel") setIsCancelModalOpen(true);
        if (action === "consent") setIsConsentModalOpen(true);
    };

    const handleRescheduleAppointment = async (data) => {
        const sessionUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

        const payload = {
            OrgId: sessionUserData?.OrgId || 1,
            UserId: sessionUserData?.Id || 1,
            Type: "RESCHEDULE",
            JsonData: {
                AppointmentId: Number(data.appointment?.AppointmentId),
                AppointmentDate: data.newDate,
                SlotTime: data.newTime,
                Notes: data.remarks,
            },
        };

        try {
            const response = await rescheduleAppointment(payload);
            const result = response?.data?.result?.[0];

            if (response?.success && result?.ResponseCode === 2006) {
                Toast.fire({
                    icon: "success",
                    title: result?.Message || "Appointment rescheduled successfully",
                });

                fetchAppointments?.();
                setIsRescheduleModalOpen(false);
            } else {
                Toast.fire({
                    icon: "error",
                    title: result?.Message || response?.message || "Failed to reschedule appointment",
                });
            }
        } catch (error) {
            console.error(error.response?.data || error.message);

            Toast.fire({
                icon: "error",
                title: error.response?.data?.message || "Failed to reschedule appointment",
            });
        }
    };

    const handleCancelAppointment = async (data) => {
        const sessionUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

        const payload = {
            OrgId: sessionUserData?.OrgId || 1,
            UserId: sessionUserData?.Id || 1,
            Type: "CANCEL",
            JsonData: {
                AppointmentId: Number(data.appointment?.AppointmentId),
                Notes: data.remarks,
            },
        };

        try {
            const response = await cancelAppointment(payload);
            const result = response?.data?.result?.[0];

            if (response?.success && result?.ResponseCode === 2007) {
                Toast.fire({
                    icon: "success",
                    title: result?.Message || "Appointment cancelled successfully",
                });

                fetchAppointments?.();
                setIsCancelModalOpen(false);
            } else {
                Toast.fire({
                    icon: "error",
                    title: result?.Message || response?.message || "Failed to cancel appointment",
                });
            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.response?.data?.message || "Failed to cancel appointment",
            });
        }
    };

    const handleRejectAppointment = async (data) => {
        const sessionUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

        const payload = {
            OrgId: sessionUserData?.OrgId || 1,
            UserId: sessionUserData?.Id || 1,
            Type: "REJECT",
            JsonData: {
                AppointmentId: Number(data.appointment?.AppointmentId),
                Notes: data.remarks,
            },
        };

        try {
            const response = await rejectAppointment(payload);
            const result = response?.data?.result?.[0];

            if (response?.success && result?.ResponseCode === 2005) {
                Toast.fire({
                    icon: "success",
                    title: result?.Message || "Appointment rejected successfully",
                });

                fetchAppointments?.();
                setIsRejectModalOpen(false);
            } else {
                Toast.fire({
                    icon: "error",
                    title: result?.Message || response?.message || "Failed to reject appointment",
                });
            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.response?.data?.message || "Failed to reject appointment",
            });
        }
    };

    const formatInputDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const getDefaultAppointmentDates = () => {
        const today = new Date();
        const next7Days = new Date();

        next7Days.setDate(today.getDate() + 30);

        return {
            fromDate: formatInputDate(today),
            toDate: formatInputDate(next7Days),
        };
    };

    const defaultDates = getDefaultAppointmentDates();

    const [filters, setFilters] = useState({
        patientName: "",
        fromDate: defaultDates.fromDate,
        toDate: defaultDates.toDate,
        status: "",
    });

    const mapAppointment = (item) => ({
        ...item,
        patient: item.PatientName,
        age: item.Age || "-",
        gender: item.Gender === 1 ? "Male" : item.Gender === 0 ? "Female" : "-",
        phone: item.Mobile,
        doctor: item.DoctorName || "-",
        date: formatDateDDMMYYYY(item.AppointmentDate),
        time: formatTime(item.SlotTime),
        status: item.Status,
    });

    useEffect(() => {
        if (!sessionUserData?.OrgId) return;

        fetchAppointments(1, pageSize, true);
    }, [sessionUserData?.OrgId, branchId]);

    const getPatientSearchParams = (value = "") => {
        const search = value.trim();

        if (!search) {
            return {
                PatientName: "",
                PhoneNumber: "",
            };
        }

        const onlyNumbers = /^\d+$/.test(search);

        if (onlyNumbers) {
            return {
                PatientName: "",
                PhoneNumber: search,
            };
        }

        return {
            PatientName: search,
            PhoneNumber: "",
        };
    };

    const buildPayload = (page = currentPage, size = pageSize) => {
        const patientSearch = getPatientSearchParams(filters.patientName);

        return {
            OrgId: Number(sessionUserData?.OrgId),
            UnitId: branchId,
            DoctorId: sessionUserData?.RoleId === 1 ? 0 : sessionUserData?.Id,
            Status: filters.status || "",
            FromDate: filters.fromDate || "",
            ToDate: filters.toDate || "",
            ...patientSearch,
            page,
            pageSize: size,
        };
    };

    const getCacheKey = (page, size) => {
        return JSON.stringify({
            OrgId: sessionUserData?.OrgId,
            UnitId: branchId,
            ...filters,
            page,
            pageSize: size,
        });
    };

    const fetchAppointments = async (page = currentPage, size = pageSize, force = false) => {
        const cacheKey = getCacheKey(page, size);

        if (!force && appointmentsCache[cacheKey]) {
            const cached = appointmentsCache[cacheKey];

            setAppointments(cached.data);
            setTotalCount(cached.totalCount);
            setCurrentPage(page);
            return;
        }

        try {
            setLoading(true);

            const payload = buildPayload(page, size);
            const response = await getAppointments(payload);

            const mappedData = (response?.data || []).map(mapAppointment);
            const count = response?.pagination?.totalCount || 0;

            setAppointments(mappedData);
            setTotalCount(count);
            setCurrentPage(page);

            setAppointmentsCache((prev) => ({
                ...prev,
                [cacheKey]: {
                    data: mappedData,
                    totalCount: count,
                },
            }));
        } catch (error) {
            console.error("Failed to fetch appointments:", error);
            setAppointments([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = (e) => {
        e.preventDefault();

        setAppointmentsCache({});
        setCurrentPage(1);
        fetchAppointments(1, pageSize, true);
    };

    const handlePageChange = (page) => {
        fetchAppointments(page, pageSize);
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
        fetchAppointments(1, size);
    };

    useEffect(() => {
        fetchAppointments(1, pageSize, true);
    }, []);

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "new":
                return "badge badge-light-info text-dark fw-bold px-3 py-2 rounded-pill";

            case "booked":
                return "badge badge-light-primary text-primary fw-bold px-3 py-2 rounded-pill";

            case "confirmed":
                return "badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill";

            case "completed":
                return "badge fw-bold px-3 py-2 rounded-pill text-white";

            case "draft":
                return "badge badge-light-secondary text-secondary fw-bold px-3 py-2 rounded-pill";

            case "rejected":
                return "badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill";

            case "canceled":
            case "cancelled":
                return "badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill";

            case "rescheduled":
                return "badge badge-light-warning text-warning fw-bold px-3 py-2 rounded-pill";

            default:
                return "badge badge-light-dark text-dark fw-bold px-3 py-2 rounded-pill";
        }
    };

    const handleConfirmAppointment = async (data) => {

        const payload = {
            OrgId: sessionUserData?.OrgId,
            UserId: sessionUserData?.Id,
            Type: "CONFIRM",
            JsonData: {
                AppointmentId: data.appointment.AppointmentId,
                DoctorId: Number(data.doctorId),
                SlotTime: data.timeSlot
            },
        };

        try {
            const response = await confirmAppointment(payload);

            if (response?.success) {
                Toast.fire({
                    icon: "success",
                    title: response?.message || "Appointment confirmed successfully",
                });

                fetchAppointments?.();
                setIsConfirmModalOpen(false);
            } else {
                Toast.fire({
                    icon: "error",
                    title: response?.message || "Failed to confirm appointment",
                });
            }
        } catch (error) {
            console.error("Confirm appointment failed:", error.response?.data || error.message);

            Toast.fire({
                icon: "error",
                title: error.response?.data?.message || "Failed to confirm appointment",
            });
        }
    };

    return (
        <>
            <DoctorLayout>
                <div className="row g-4 p-2">
                    <div className="col-12">
                        <div className="card border-0 rounded-4 shadow-sm my-4 dashboard-section-card">
                            <div className="card-body p-3 p-lg-4">
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="card border-0 rounded-4 shadow-sm-sm bg-white">
                                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4 flex-wrap">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div
                                                        className="rounded-circle bg-light-info d-flex align-items-center justify-content-center shadow-sm"
                                                        style={{ width: "50px", height: "50px" }}
                                                    >
                                                        <i className="bi bi-table text-info fs-4"></i>
                                                    </div>

                                                    <div>
                                                        <h3 className="fw-bold text-dark mb-1">Appointments</h3>
                                                        <div className="text-muted fs-7">Today and upcoming consultations</div>
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn fw-bold btn-sm d-inline-flex align-items-center gap-2 border-0 shadow-sm"
                                                    onClick={() => setShowAppointmentModal(true)}
                                                    style={{
                                                        background: "linear-gradient(135deg, #0f766e 0%, #2563eb 100%)",
                                                        color: "#fff",
                                                        borderRadius: "12px",
                                                        padding: "10px 16px",
                                                        boxShadow: "0 10px 22px rgba(37, 99, 235, 0.22)",
                                                    }}
                                                >
                                                    <span
                                                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-25"
                                                        style={{ width: "26px", height: "26px" }}
                                                    >
                                                        <i className="bi bi-plus-lg text-white"></i>
                                                    </span>
                                                    <span>Make Appointment</span>
                                                </button>
                                            </div>

                                            <div className="card-body p-4">
                                                <form onSubmit={handleSearch}>
                                                    <div className="row g-3 align-items-end">
                                                        {sessionUserData?.RoleId === 1 && (
                                                            <div className="col-12 col-md-6 col-xl-2">
                                                                <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                                                    Branch
                                                                </label>
                                                                <select
                                                                    name="status"
                                                                    className="form-select form-select-sm rounded-3"
                                                                    value={branchId}
                                                                    onChange={(e) => setBranchId(e.target.value)}
                                                                >
                                                                    <option value="1">Branch-01</option>
                                                                    <option value="2">Branch-02</option>
                                                                </select>
                                                            </div>
                                                        )}
                                                        <div className="col-12 col-md-6 col-xl-3">
                                                            <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                                                Patient Name
                                                            </label>

                                                            <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    name="patientName"
                                                                    className="form-control form-control-sm rounded-3 pe-10"
                                                                    placeholder="Search by Patient Name or Phone"
                                                                    value={filters.patientName}
                                                                    onChange={handleChange}
                                                                />

                                                                {filters.patientName && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-1 text-muted"
                                                                        onClick={() =>
                                                                            setFilters((prev) => ({
                                                                                ...prev,
                                                                                patientName: "",
                                                                            }))
                                                                        }
                                                                        style={{
                                                                            width: "28px",
                                                                            height: "28px",
                                                                            border: 0,
                                                                            background: "transparent",
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-x-circle-fill"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-2">
                                                            <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                                                From Date
                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="fromDate"
                                                                className="form-control form-control-sm rounded-3"
                                                                value={filters.fromDate}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-2">
                                                            <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                                                To Date
                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="toDate"
                                                                className="form-control form-control-sm rounded-3"
                                                                value={filters.toDate}
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className="col-12 col-md-6 col-xl-2">
                                                            <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                                                Status
                                                            </label>
                                                            <select
                                                                name="status"
                                                                className="form-select form-select-sm rounded-3"
                                                                value={filters.status}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">All Status</option>
                                                                <option value="NEW">New</option>
                                                                <option value="BOOKED">Booked</option>
                                                                <option value="CONFIRMED">Confirmed</option>
                                                                <option value="COMPLETED">Completed</option>
                                                                <option value="DRAFT">Draft</option>
                                                                <option value="REJECTED">Rejected</option>
                                                                <option value="CANCELED">Canceled</option>
                                                                <option value="RESCHEDULED">Rescheduled</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-12 col-md-4 col-xl-1">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-sm px-4 w-100 rounded-3 shadow-sm"
                                                            >
                                                                <i className="bi bi-search me-2"></i>
                                                                Search
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="card border-0 rounded-4 shadow-sm bg-white">
                                            <div className="card-body p-4 p-lg-5">
                                                <div className="table-responsive">
                                                    <table className="table align-middle table-row-dashed mb-0">
                                                        <thead>
                                                            <tr className="fw-bold text-dark" style={{ backgroundColor: "#dbe8fb" }}>
                                                                <th className="ps-5">Patient</th>
                                                                <th>Age</th>
                                                                <th>Gender</th>
                                                                <th>Date</th>
                                                                <th>Time</th>
                                                                <th>Status</th>
                                                                <th>Doctor</th>
                                                                <th className="text-center">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody className="fw-semibold text-gray-700">
                                                            {loading ? (
                                                                <tr>
                                                                    <td colSpan="8" className="p-0">
                                                                        <PremiumLoader
                                                                            text="Loading appointments"
                                                                            subText="Fetching today's consultation list"
                                                                            height="260px"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) : appointments.length > 0 ? (
                                                                appointments.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td className="ps-5 fw-bold text-dark">{item.patient}</td>
                                                                        <td>{item.age}</td>
                                                                        <td>{item.gender}</td>
                                                                        <td>{item.date}</td>
                                                                        <td>{item.time}</td>
                                                                        <td>
                                                                            <span
                                                                                className={getStatusBadge(item.status)}
                                                                                style={item.status?.toLowerCase() === "completed" ? { backgroundColor: "#14b8a6" } : {}}
                                                                            >
                                                                                {item.status}
                                                                            </span>
                                                                        </td>
                                                                        <td>{item.doctor}</td>
                                                                        <td className="text-center">
                                                                            <Dropdown
                                                                                menu={{ items: getActionItems(item) }}
                                                                                trigger={["click"]}
                                                                                placement="bottomRight"
                                                                                overlayClassName="appointment-action-menu"
                                                                            >
                                                                                <Button
                                                                                    type="text"
                                                                                    className="btn btn-light-primary btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0 shadow-sm"
                                                                                    style={{ width: "34px", height: "34px" }}
                                                                                    icon={<MoreOutlined />}
                                                                                />
                                                                            </Dropdown>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center py-10 text-muted fw-semibold">
                                                                        No appointments found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>

                                                    <Pagination
                                                        currentPage={currentPage}
                                                        totalCount={totalCount}
                                                        pageSize={pageSize}
                                                        onPageChange={handlePageChange}
                                                        onPageSizeChange={handlePageSizeChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ConfirmAppointmentModal
                    open={isConfirmModalOpen}
                    onClose={() => setIsConfirmModalOpen(false)}
                    onConfirm={handleConfirmAppointment}
                    appointment={selectedAppointment}
                />

                <RescheduleAppointmentModal
                    open={isRescheduleModalOpen}
                    onClose={() => setIsRescheduleModalOpen(false)}
                    onSubmit={handleRescheduleAppointment}
                    appointment={selectedAppointment}
                />

                <RejectAppointmentModal
                    open={isRejectModalOpen}
                    onClose={() => setIsRejectModalOpen(false)}
                    onSubmit={handleRejectAppointment}
                    appointment={selectedAppointment}
                />

                <CancelAppointmentModal
                    open={isCancelModalOpen}
                    onClose={() => setIsCancelModalOpen(false)}
                    onSubmit={handleCancelAppointment}
                    appointment={selectedAppointment}
                />

                <AppointmentModal
                    show={showAppointmentModal}
                    onClose={() => setShowAppointmentModal(false)}
                    onSuccess={fetchAppointments}
                />

                <EditAppointmentModal
                    show={isEditModalOpen}
                    appointment={selectedAppointment}
                    onClose={() => setIsEditModalOpen(false)}
                    onSuccess={fetchAppointments}
                />

                <ConcernAppointmentModal
                    open={isConsentModalOpen}
                    onClose={() =>
                        setIsConsentModalOpen(false)
                    }
                    appointment={selectedAppointment}
                />
            </DoctorLayout>

            <style>
                {`
                .appointment-action-menu .ant-dropdown-menu {
                    border-radius: 14px;
                    padding: 8px;
                    box-shadow: 0 14px 34px rgba(15, 23, 42, 0.14);
                    }

                    .appointment-action-menu .ant-dropdown-menu-item {
                    border-radius: 10px;
                    padding: 8px 12px;
                    }
                    .dashboard-panel-card,
                    .dashboard-stat-card,
                    .schedule-item-card {
                        transition: all 0.25s ease;
                    }

                    .dashboard-panel-card:hover {
                        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.08) !important;
                    }

                    .dashboard-stat-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.14) !important;
                    }

                    .schedule-item-card:hover {
                        transform: translateY(-2px);
                        background: #ffffff !important;
                        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
                        border-color: #dbe8fb !important;
                    }


                `}
            </style>
        </>
    );
}
